import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import PrimaryButton from 'components/buttons/PrimaryButton';

import { RESULT_TEST_ID, SEND_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SendToDroneControl: FunctionComponent<Props> = ({
    isDisabled,
    label,
    onClick,
    resultText,
    testId = TEST_ID
}) => (
    <VerticalContainer className={styles.sendToDroneControl} testId={testId}>
        <PrimaryButton
            className={styles.sendButton}
            isDisabled={isDisabled}
            onClick={onClick}
            testId={SEND_BUTTON_TEST_ID}
            text={label}
        />

        {resultText === null ? null : (
            <Wrapper className={styles.resultText} testId={RESULT_TEST_ID}>
                {resultText}
            </Wrapper>
        )}
    </VerticalContainer>
);

export default SendToDroneControl;
